export const GET_EMPLOYEE_TRANSACTION = 'GET_EMPLOYEE_TRANSACTION';
export const SET_EMPLOYEE_TRANSACTION = 'SET_EMPLOYEE_TRANSACTION';
export const GET_BUSINESS_TRANSACTION = 'GET_BUSINESS_TRANSACTION';
export const SET_BUSINESS_TRANSACTION = 'SET_BUSINESS_TRANSACTION';
